<a [routerLink]="['/store/garmin-watches', product.handle]" class="product-card-link">
    <div class="product-card">

        <div class="img-card">
            <div class="">
                <img height="200" width="200" src="{{product.featuredImage.url}}"
                    alt="{{product.featuredImage.altText}}" fill />
            </div>
        </div>

        <div class="text-container">

            <h2 class="title">{{product.title}}</h2>

            <div class="price-container">
                <ng-container
                    *ngIf="product.variants.edges[0].node.compareAtPrice.amount > product.variants.edges[0].node.price.amount">
                    <div class="comparison">
                        <span class="original">
                            ₹ {{product.variants.edges[0].node.compareAtPrice.amount | number:'1.0-0' }} </span>
                        <span class="highlight">Save ₹ {{(product.variants.edges[0].node.compareAtPrice.amount -
                            product.variants.edges[0].node.price.amount) | number:'1.0-0'}}</span>
                    </div>
                </ng-container>

                <div class="price">
                    ₹{{product.variants.edges[0].node.price.amount | number:'1.0-0'}}
                </div>
            </div>

            <h3 class="description">
                {{product.description}}
            </h3>
        </div>
    </div>
</a>